import React, { useEffect, useState } from 'react'
import ParticlesBg from "particles-bg";
import FadeIn from "react-fade-in";
import './Home.css'
import { useTimer } from 'react-timer-hook';
import { Button, makeStyles, Modal, Paper, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Cookies from 'universal-cookie';
import ReactHtmlParser from 'html-react-parser';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
export default function Home() {
    const [contentHeader, setContentHeader] = useState([]);
    const [modalHome, setModalHome] = useState(false);
    const [time, setTime] = useState(new Date());
    const [showTime, setShowTime] = useState(false);
    const cookies = new Cookies();
    const [contentInfo, setContentInfo] = useState(null);
    const userToken = cookies.get('tokenCTF');
    const [showPractice, setShowPractice] = useState(false);
    const useStyles = makeStyles(theme => ({
        modal: {
            width: 500,
            backgroundColor: 'white',
            border: '2px solid #000',
            borderRadius: '10px',
            boxShadow: theme.shadows[5],
            //padding: '16px 32px 24px',
            padding: theme.spacing(2, 4, 3, 4),
            marginTop: '20%',
            marginLeft: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        modalButton: {
            backgroundColor: 'gray',

        },
        contentPost: {
            margin: theme.spacing(10),
            padding: theme.spacing(3),
            wordWrap: 'break-word',
        },
        info:{
            backgroundColor: '#0A0F15',
            width: '100%',
            paddingTop: '5px',
            paddingBottom: '10px',
        }
        

    }))
    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {

        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/settings/getTimersUser`, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF');
                history.push('/login');

            } else {
                if (res.data.notStart) {
                    time.setSeconds(time.getSeconds() + res.data.totalSeconds);
                    setShowTime(true);
                    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/settings/getHomeInfo`).then(res2 => {
                        setContentHeader({ title: res2.data.title, content: 'Próximamente.' })
                        setShowPractice(true);
                    })
                }
                else {
                    time.setSeconds(0);
                    setShowTime(false);
                    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/settings/getHomeInfo`, {
                        headers: { 'Authorization': userToken }
                    }).then(res3 => {
                        if (res.data.finish) {
                            setContentHeader({ title: res3.data.title, content: 'La competencia ha finalizado.' })
                            setShowPractice(true);
                        }
                        else if (res.data.running) {
                            setContentHeader({ title: res3.data.title, content: 'Competencia en curso.' })
                            setShowPractice(false);
                        }
                        else {
                            setContentHeader({ title: res3.data.title, content: res3.data.content })
                            setShowPractice(true);
                        }

                    })


                }
            }

        })


    }, [])
    useEffect(() => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/settings/getCompetitionInfo`, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF');
                history.push('/login');
            }
            else {
                if(res.data.information!=""){
                    setContentInfo(res.data);
                }
                else{
                    setContentInfo(null);
                }
            }
        })
    }, [])
    function MyTimer({ expiryTimestamp, showTime }) {
        const {
            seconds,
            minutes,
            hours,
            days,
        } = useTimer({ expiryTimestamp, onExpire: () => console.warn('onExpire called') });


        return (
            <div className={ showTime ? "timer visible" : "timer displayNone"} >
                <div className="time-card-begin">{days}<div className="time-desc">días</div></div>
                <div className="time-card">{hours}<div className="time-desc">horas</div></div>
                <div className="time-card">{minutes}<div className="time-desc">minutos</div></div>
                <div className="time-card">{seconds}<div className="time-desc">segundos</div></div>
            </div>
        );
    }

    return (
        <>
            <div className="home-body">
                <div className="home">
                    <ParticlesBg type="lines" bg={true} />
                    <div className="banner-text">
                        <FadeIn>
                            <h1 className="responsive-headline">{contentHeader.title} </h1>
                        </FadeIn>
                        <FadeIn>
                            <h5 className="responsive-description">{contentHeader.content} </h5>
                        </FadeIn>
                        <FadeIn >
                            <MyTimer expiryTimestamp={time} showTime={showTime} />
                        </FadeIn>
                        <FadeIn>
                            <button className={ showPractice ? "button-rules visible" : "button-rules displayNone"}  onClick={() => { history.push('/user/aprendizaje') }}>PRACTICAR</button>
                            <button className={ showPractice ? "button-rules displayNone" : "button-rules visible"}  onClick={() => { history.push('/user/retos') }}>PARTICIPAR</button>

                        </FadeIn>

                    </div>
                </div>

            </div>
            <div className="info">
                {contentInfo? contentInfo.map((value) => {
                    return (
                        <>
                            <Paper className="contentPost">
                                {ReactHtmlParser(value.information)}
                            </Paper>
                        </>
                    )
                }):''}
            </div>
        </>
    )
}